var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"9b471d6af2d58b9f9fcba965dbf0946ee1912a90"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'

import { APP_VERSION, SENTRY_DSN } from './src/lib/constants'

Sentry.init({
  dsn: SENTRY_DSN,
  release: APP_VERSION,
  tracesSampleRate: 0,
  enabled: process.env.NODE_ENV !== 'development',
  environment:
    process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT || 'unknown-environment',

  beforeSend(event) {
    const errorMessage = event.exception?.values?.[0]?.value || ''
    const errorType = event.exception?.values?.[0]?.type || ''

    // General patterns for common external script errors
    if (errorType === 'TypeError') {
      // Browser API misuse errors (usually external scripts)
      if (
        errorMessage.includes('requestAnimationFrame') ||
        errorMessage.includes('requestIdleCallback') ||
        errorMessage.includes('parameter 1 is not of type')
      ) {
        return null
      }

      // More specific DOM errors that are likely external
      if (
        (errorMessage.includes('document.querySelector') &&
          errorMessage.includes('addEventListener')) ||
        (errorMessage.includes('document.getElementById') &&
          errorMessage.includes('null'))
      ) {
        return null
      }
    }

    // Known external script domains/services
    if (
      errorMessage.includes('cookielaw.org') ||
      errorMessage.includes('visualwebsiteoptimizer.com') ||
      errorMessage.includes('googletagmanager.com') ||
      errorMessage.includes('google-analytics.com') ||
      errorMessage.includes('facebook.com') ||
      errorMessage.includes('BrowserAgentSearchDetection') ||
      errorMessage.includes('PageTranslationRequiredListener') ||
      errorMessage.includes('enableDidUserTypeOnKeyboardLogging') ||
      errorMessage.includes('Java object is gone') ||
      (errorMessage.includes('undefined is not an object') &&
        errorMessage.includes('t.Domain')) ||
      errorMessage.includes('attempted to hard navigate to the same URL')
    ) {
      return null
    }

    // Fallback: Stack trace analysis for cases we haven't covered
    if (event.exception?.values?.[0]?.stacktrace?.frames) {
      const frames = event.exception.values[0].stacktrace.frames

      // Check if any frame is from our internal code
      const hasInternalFrames = frames.some(
        (frame) =>
          frame.filename?.includes('/_next/') || // Next.js bundle
          frame.filename?.includes('webpack://') || // Webpack modules
          frame.filename?.includes(window.location.origin) // Our domain
      )

      // If no internal frames, filter out
      if (!hasInternalFrames) {
        return null
      }
    }

    return event
  },
})
